import {FC} from "react";
import {Stack} from "@mui/material";

const campfireTear1 = "/campfire_lv-1_data.svg";
const campfireTear2 = "/campfire_lv-2_data.svg";
const campfireTear3 = "/campfire_lv-3_data.svg";
const campfireTear4 = "/campfire_lv-4_data.svg";

interface PauseStreakDrawerContentProps {
	streakDays: number;
	width: string;
	height: string;
}

const PauseStreakDrawerContent: FC<PauseStreakDrawerContentProps> = ({
	streakDays,
	width,
	height
}) => {
	let image = campfireTear1;

	if (streakDays > 0){
		image = campfireTear2;
		if (streakDays > 1){
			image = campfireTear3;
		}

		if (streakDays > 100){
			image = campfireTear4;
		}
	}

	return (
		<Stack
			sx={{
				justifyContent: "center",
				alignItems: "center"
			}}
		>
			<img
				src={image}
				alt={"Campfire animated image"}
				width={width}
				height={height}
			/>
		</Stack>
	)
}

export default PauseStreakDrawerContent;

